import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

const AboutSection = styled.section`
  padding: ${theme.spacing.xxl} 0;
  background-color: ${theme.colors.gray.light};
`;

const Container = styled.div`
  max-width: ${theme.breakpoints.desktop};
  margin: 0 auto;
  padding: 0 ${theme.spacing.xl};
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${theme.spacing.xl};
  align-items: center;

  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`;

const Content = styled.div`
  h2 {
    font-size: 2.5rem;
    margin-bottom: ${theme.spacing.lg};
    color: ${theme.colors.primary};
  }

  p {
    margin-bottom: ${theme.spacing.md};
    font-size: 1.1rem;
    color: ${theme.colors.gray.dark};
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  height: 500px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: ${theme.borderRadius.medium};
  }

  &::after {
    content: '';
    position: absolute;
    top: ${theme.spacing.md};
    left: ${theme.spacing.md};
    right: -${theme.spacing.md};
    bottom: -${theme.spacing.md};
    border: 2px solid ${theme.colors.secondary};
    border-radius: ${theme.borderRadius.medium};
    z-index: 1;
  }
`;

const Stats = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${theme.spacing.lg};
  margin-top: ${theme.spacing.xl};
  text-align: center;

  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-template-columns: repeat(2, 1fr);
  }

  p {
    color: #000000;
    font-weight: 700;
  }
`;

const StatItem = styled.div`
  h3 {
    font-size: 2.5rem;
    color: ${theme.colors.secondary};
    margin-bottom: ${theme.spacing.xs};
  }

  p {
    font-size: 1rem;
    color: #000000;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 700;
  }
`;

const About: React.FC = () => {
  const stats = [
    { number: '10+', label: 'Years Experience' },
    { number: '50+', label: 'Expert Woodsmen' },
    { number: '4', label: 'Global Branches' },
    { number: '3K+', label: 'Projects Completed' },
  ];

  return (
    <AboutSection id="about">
      <Container>
        <Grid>
          <Content>
            <h2>Excellence in Wood Craftsmanship</h2>
            <p>
              Jupiter & Co has been at the forefront of the timber industry for over a decade,
              delivering exceptional quality wood products and solutions to clients worldwide.
            </p>
            <p>
              Our commitment to sustainable practices, combined with state-of-the-art
              processing facilities and expert craftsmanship, ensures that every piece
              of timber we deliver meets the highest standards of quality and durability.
            </p>
            <Stats>
              {stats.map((stat, index) => (
                <StatItem key={index}>
                  <h3>{stat.number}</h3>
                  <p>{stat.label}</p>
                </StatItem>
              ))}
            </Stats>
          </Content>
          <ImageWrapper>
            <img src="/images/hero/craftmanship.jpg" alt="Wood craftsmanship" />
          </ImageWrapper>
        </Grid>
      </Container>
    </AboutSection>
  );
};

export default About; 